import * as React from "react";
import { locKeys } from "./l10n";
import { timesCannonical } from "./config";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkSelect } from "uitk-react-select";
import { TimeDropdownProps } from "./typings";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";

export const TimeDropdown: React.FunctionComponent<TimeDropdownProps> = (props) => {
  const { labelKey, timeValues, invalidKey, colSpan, onChange, value, use12hr } = props;
  const keyHelper = new ItemKeyHelper("TimeDropdown");
  const { formatText } = useLocalization();
  const label = formatText(labelKey);
  const use12HourTime = use12hr ? use12hr : false;

  if (timeValues?.length === 0) return null;

  const optionListItems = timesCannonical.map((time, index) => (
    <option data-time={time} value={timeValues[index]} key={keyHelper.next()}>
      {use12HourTime ? formatText(locKeys.time12hrs[index]) : formatText(locKeys.time24hrs[index])}
    </option>
  ));

  return (
    <UitkLayoutGridItem colSpan={colSpan}>
      <div>
        <UitkSelect
          aria-label={label}
          icon="access_time"
          invalid={formatText(invalidKey!)}
          label={label}
          onChange={onChange}
          value={value}
        >
          {optionListItems}
        </UitkSelect>
      </div>
    </UitkLayoutGridItem>
  );
};
